import googleTagManager from '@analytics/google-tag-manager';
import hubSpotPlugin from '@analytics/hubspot';
import Analytics from 'analytics';

const IS_DEV_ENV = process.env.NODE_ENV === 'development';
const IS_PROD_ENV = process.env.NODE_ENV === 'production';

const devOnlyPlugins = [
  {
    name: 'logger',
    page: ({ payload }: { payload: unknown }) => {
      console.info('analytics-page', payload);
    },
    track: ({ payload }: { payload: unknown }) => {
      console.info('analytics-track', payload);
    },
    identify: ({ payload }: { payload: unknown }) => {
      console.info('analytics-identify', payload);
    },
  },
];

const prodOnlyPlugins = [
  googleTagManager({
    containerId: 'GTM-TRRXBNQB',
  }),
  hubSpotPlugin({
    portalId: '26630649',
  }),
];

const plugins = [...(IS_DEV_ENV ? devOnlyPlugins : []), ...(IS_PROD_ENV ? prodOnlyPlugins : [])];

export default Analytics({
  app: 'quickchat-app',
  debug: IS_DEV_ENV,
  plugins,
});
